import {
  createThis2j2avj17cvnv2 as createThis,
  toString1pkumu07cwy4m as toString,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { Companion_getInstance3d08n7snrwep7 as Companion_getInstance } from './ExecutionContext.mjs';
import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { emptyMapr06gerzljqtm as emptyMap } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/Maps.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  DefaultApolloException8w3ielfxng0h as DefaultApolloException,
  ApolloGraphQLException2qazyzs4ebcad as ApolloGraphQLException,
  NoDataException34qvcinicy2ih as NoDataException,
} from '../exception/Exceptions.mjs';
import { ensureNotNull1e947j3ixpazm as ensureNotNull } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { first58ocm7j58k3q as first } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { getKClassFromExpression348iqjl4fnx2f as getKClassFromExpression } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var BuilderClass;
function Builder() {
  if (BuilderClass === VOID) {
    class $ {
      static f44(operation, requestUuid, data, errors, extensions, exception) {
        var $this = createThis(this);
        $this.x43_1 = operation;
        $this.y43_1 = requestUuid;
        $this.z43_1 = data;
        $this.a44_1 = errors;
        $this.b44_1 = extensions;
        $this.c44_1 = exception;
        $this.d44_1 = Companion_getInstance().u42_1;
        $this.e44_1 = false;
        return $this;
      }
      static g44(operation, requestUuid) {
        return this.f44(operation, requestUuid, null, null, null, null);
      }
      h44(executionContext) {
        // Inline function 'kotlin.apply' call
        this.d44_1 = this.d44_1.i44(executionContext);
        return this;
      }
      j44(data) {
        // Inline function 'kotlin.apply' call
        this.z43_1 = data;
        return this;
      }
      k44(errors) {
        // Inline function 'kotlin.apply' call
        this.a44_1 = errors;
        return this;
      }
      l44(exception) {
        // Inline function 'kotlin.apply' call
        this.c44_1 = exception;
        return this;
      }
      m44(extensions) {
        // Inline function 'kotlin.apply' call
        this.b44_1 = extensions;
        return this;
      }
      v42(requestUuid) {
        // Inline function 'kotlin.apply' call
        this.y43_1 = requestUuid;
        return this;
      }
      n44(isLast) {
        // Inline function 'kotlin.apply' call
        this.e44_1 = isLast;
        return this;
      }
      p37() {
        var tmp1_operation = this.x43_1;
        var tmp2_requestUuid = this.y43_1;
        var tmp3_data = this.z43_1;
        var tmp4_executionContext = this.d44_1;
        var tmp0_elvis_lhs = this.b44_1;
        var tmp5_extensions = tmp0_elvis_lhs == null ? emptyMap() : tmp0_elvis_lhs;
        var tmp6_errors = this.a44_1;
        var tmp7_exception = this.c44_1;
        var tmp8_isLast = this.e44_1;
        return new (ApolloResponse())(tmp2_requestUuid, tmp1_operation, tmp3_data, tmp6_errors, tmp7_exception, tmp5_extensions, tmp4_executionContext, tmp8_isLast);
      }
    }
    initMetadataForClass($, 'Builder');
    BuilderClass = $;
  }
  return BuilderClass;
}
var ApolloResponseClass;
function ApolloResponse() {
  if (ApolloResponseClass === VOID) {
    class $ {
      constructor(requestUuid, operation, data, errors, exception, extensions, executionContext, isLast) {
        this.o44_1 = requestUuid;
        this.p44_1 = operation;
        this.q44_1 = data;
        this.r44_1 = errors;
        this.s44_1 = exception;
        this.t44_1 = extensions;
        this.u44_1 = executionContext;
        this.v44_1 = isLast;
      }
      w44() {
        var tmp;
        if (this.k45()) {
          throw ApolloGraphQLException().j45(first(ensureNotNull(this.r44_1)));
        } else if (!(this.s44_1 == null)) {
          throw DefaultApolloException().c45('An exception happened', this.s44_1);
        } else {
          tmp = this.x44();
        }
        return tmp;
      }
      x44() {
        var tmp0_elvis_lhs = this.q44_1;
        var tmp;
        if (tmp0_elvis_lhs == null) {
          throw NoDataException().p45(this.s44_1);
        } else {
          tmp = tmp0_elvis_lhs;
        }
        return tmp;
      }
      k45() {
        // Inline function 'kotlin.collections.isNullOrEmpty' call
        var this_0 = this.r44_1;
        return !(this_0 == null || this_0.n1());
      }
      v43() {
        return Builder().f44(this.p44_1, this.o44_1, this.q44_1, this.r44_1, this.t44_1, this.s44_1).h44(this.u44_1).n44(this.v44_1);
      }
      toString() {
        var tmp = 'operationName=' + this.p44_1.operationName() + ', ';
        var tmp_0 = 'data=' + (this.q44_1 == null ? 'null' : this.p44_1.operationName() + '.Data') + ', ';
        var tmp0_safe_receiver = this.r44_1;
        var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.q2();
        var tmp_1 = 'errors=' + toString(tmp1_elvis_lhs == null ? 'null' : tmp1_elvis_lhs) + ', ';
        var tmp_2;
        if (this.s44_1 == null) {
          tmp_2 = 'null';
        } else {
          var tmp2_elvis_lhs = getKClassFromExpression(this.s44_1).j1();
          tmp_2 = tmp2_elvis_lhs == null ? 'true' : tmp2_elvis_lhs;
        }
        return 'ApolloResponse(' + tmp + tmp_0 + tmp_1 + ('exception=' + tmp_2) + ')';
      }
    }
    initMetadataForClass($, 'ApolloResponse');
    ApolloResponseClass = $;
  }
  return ApolloResponseClass;
}
//region block: exports
export {
  Builder as Builder16nv925388a0q,
  ApolloResponse as ApolloResponse1aeginapbuksm,
};
//endregion

//# sourceMappingURL=ApolloResponse.mjs.map
